import { engineComponent } from "neo-common";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { HtmlContainerElement } from "../Elements/HtmlContainerElement";
import { BetManager } from "../../Managers/BetManager";
import { AppContext } from "../../../Common/AppContext";
import { HtmlButtonElement } from "../Elements/HtmlButtonElement";
import { RouletteActions } from "../../Channels/Common/Actions/RouletteActions";
import { ChipConfiguration } from "../../CustomComponents/ChipConfiguration";
import { HtmlTouchContainerElement } from "../../CustomComponents/HtmlTouchContainerElement";
import { HtmlController } from "../HtmlController";
import { Scaling } from "../../Utils/Scaling";
import { CustomUtils } from "../../Utils/CustomUtils";
import { HtmlElement } from "../Elements/HtmlElement";

@engineComponent(ComponentTypes.HtmlElement)
export class HtmlChipSelectorContainerElement extends HtmlTouchContainerElement {
    private static readonly VisibleCount = 3;

    private static Selected: string = "_selected";

    private _chips: Array<HtmlButtonElement>;

    private _chipCount: number;

    private _chipWidth: number;

    private _chipIndex: number;

    private _container: HTMLElement;

    private _containerIndex: number;

    private _leftControlBtn: HtmlButtonElement;

    private _rightControlBtn: HtmlButtonElement;

    constructor() {
        super();

        this._chips = [];
        this._containerIndex = -1;
        BetManager.ChipSelector = this;
    }

    create(node: Element): void {
        super.create(node);
        this._container = <HTMLElement>this.instance.getElementsByClassName("chipSelectorInner")[0];

        this.createSwipeControls();
    }

    public addValues(): void {
        if (!AppContext.gameConfiguration.UseCoins && BetManager.Chips != null) {
            let chip: HtmlButtonElement;
            this._chipCount = BetManager.Chips.length;

            for (let i: number = 0; i < BetManager.Chips.length; i++) {
                chip = this.createButtonElement(BetManager.Chips[i], i);

                if (this._container != null) {
                    this._container.appendChild(chip.instance);
                    this._chips.push(chip);
                }
            }

            if (chip != null) {
                this._chipWidth = parseInt(window.getComputedStyle(chip.instance).width);
                this._chipWidth += parseInt(window.getComputedStyle(chip.instance).marginLeft);
                this._chipWidth += parseInt(window.getComputedStyle(chip.instance).marginRight);
                this.setupChipSelector();
            }

            this.createControls();
        }
    }

    public selectChip(index: number): void {
        if (index > -1 && index < this._chips.length) {
            if (index == this._chipIndex) {
                return;
            }

            this.unselectAll();
            if (index > this._chipIndex) {
                this.moveSelectorToRight();
            } else {
                this.moveSelectorToLeft();
            }

            this._chipIndex = index;
            this._chips[index].instance.classList.add(HtmlChipSelectorContainerElement.Selected);
            this.updateControls();

            CustomUtils.incrementActionCount("CHIP_CHANGE");
        }
    }

    public moveSelectorToLeft(): number {
        if (this._containerIndex > -1) {
            this._containerIndex--;

            if (this._chipIndex > this._containerIndex + HtmlChipSelectorContainerElement.VisibleCount - 1) {
                this.selectChip(this._chipIndex - 1);
            }

            this.setSelectorTransform();
        } else {
            this.selectChip(this._chipIndex - 1);
        }

        return this._chipIndex;
    }

    public moveSelectorToRight(): number {
        if (this._containerIndex < this._chips.length - HtmlChipSelectorContainerElement.VisibleCount + 1) {
            this._containerIndex++;

            if (this._chipIndex < this._containerIndex) {
                this.selectChip(this._chipIndex + 1);
            }

            this.setSelectorTransform();
        } else {
            this.selectChip(this._chipIndex + 1);
        }

        return this._chipIndex;
    }

    private unselectAll(): void {
        for (let i = 0; i < this._chips.length; i++) {
            this._chips[i].instance.classList.remove(HtmlChipSelectorContainerElement.Selected);
        }
    }

    private setupChipSelector(force: boolean = false): void {
        if (this._container != null) {
            this._container.style.width = this._chipWidth * this._chipCount + "px";
            this.instance.style.width = this._chipWidth * HtmlChipSelectorContainerElement.VisibleCount + "px";

            let offset = Math.floor(HtmlChipSelectorContainerElement.VisibleCount / 2);
            this._containerIndex = this._chipIndex - offset;

            this.setSelectorTransform(force);
        }
    }

    private setSelectorTransform(force: boolean = false): void {
        if (force) {
            this._container.style.transitionDuration = "0s";
        }

        this._container.style.transform = "translate3d(" + this._chipWidth * this._containerIndex * -1 + "px,0,0)";
        this._container.offsetWidth;
        this._container.style.transitionDuration = "";
    }

    private createButtonElement(value: number, index: number): HtmlButtonElement {
        let node: Element = document.createElement("div");
        let chipIndex = ChipConfiguration.colors[BetManager.Chips.length][index];
        let className = "chip chip" + chipIndex;

        if (BetManager.Chip != null && BetManager.Chip == value) {
            className += " " + HtmlChipSelectorContainerElement.Selected;
            this._chipIndex = index;
        }

        node.setAttribute("CssClass", className);

        if (window["CHANNEL"] != "mobile") {
            node.setAttribute("Action", RouletteActions.ActionBetSelectValue + index);
        }

        let elem = new HtmlButtonElement();
        elem.create(node);
        elem.setText(CustomUtils.abbreviateNumber(value));

        return elem;
    }

    private createControls(): void {
        let holder = document.getElementById("chipSelectorControls");

        if (holder != null) {
            this._leftControlBtn = this.createControlButtonElement(
                "roundBtn directionBtn left",
                RouletteActions.ActionBetSelectValue + "0",
            );
            this._rightControlBtn = this.createControlButtonElement(
                "roundBtn directionBtn right",
                RouletteActions.ActionBetSelectValue + (this._chipCount - 1),
            );

            this.updateControls();

            holder.appendChild(this._leftControlBtn.instance);
            holder.appendChild(this._rightControlBtn.instance);
        }
    }

    private createControlButtonElement(className: string, action: string): HtmlButtonElement {
        let node: Element = document.createElement("div");
        node.setAttribute("CssClass", className);
        node.setAttribute("Action", action); //add dummy action to add handlers

        let elem = new HtmlButtonElement();
        elem.create(node);

        return elem;
    }

    private updateControls(): void {
        if (this._leftControlBtn != null && this._rightControlBtn != null) {
            if (this._chipIndex > 0) {
                this._leftControlBtn.action = RouletteActions.ActionBetSelectValue + (this._chipIndex - 1);
            }
            if (this._chipIndex == 0) {
                this._leftControlBtn.instance.classList.add("_hidden");
            } else {
                this._leftControlBtn.instance.classList.remove("_hidden");
            }

            if (this._chipIndex < this._chips.length - 1) {
                this._rightControlBtn.action = RouletteActions.ActionBetSelectValue + (this._chipIndex + 1);
            }

            if (this._chipIndex == this._chips.length - 1) {
                this._rightControlBtn.instance.classList.add("_hidden");
            } else {
                this._rightControlBtn.instance.classList.remove("_hidden");
            }
        }
    }

    private createSwipeControls(): void {
        if (window["CHANNEL"] == "mobile") {
            this.on(HtmlTouchContainerElement.evMoveRight, this.swipeMinus.bind(this, false));
            this.on(HtmlTouchContainerElement.evMoveUp, this.swipeMinus.bind(this, true));

            this.on(HtmlTouchContainerElement.evMoveLeft, this.swipePlus.bind(this, false));
            this.on(HtmlTouchContainerElement.evMoveDown, this.swipePlus.bind(this, true));
        }
    }

    private swipePlus(inPortrait: boolean): void {
        if ((Scaling.isPortrait() && inPortrait) || (!Scaling.isPortrait() && !inPortrait)) {
            HtmlController.dispatchAction(RouletteActions.ActionBetSelectValue + (this._chipIndex + 1));
        }
    }

    private swipeMinus(inPortrait: boolean): void {
        if ((Scaling.isPortrait() && inPortrait) || (!Scaling.isPortrait() && !inPortrait)) {
            HtmlController.dispatchAction(RouletteActions.ActionBetSelectValue + (this._chipIndex - 1));
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/HTMLComponents/Custom/HtmlChipSelectorContainerElement.ts
 **/